import { Store } from "vuex";
import { getModule } from "vuex-module-decorators";
import Blog from "~/store/blog";
import CaclulatorStore from "~/store/calculator";
import Checkout from "~/store/checkout";
import EsyoilStore from "~/store/esyoil";
import Federalstates from "~/store/federalstates";
import Oilprice from "~/store/oilprice";
import Partner from "~/store/partner";
import User from "~/store/user";
import Widerruf from "~/store/widerruf";

let _CaclulatorStore: CaclulatorStore;
let _BlogStore: Blog;
let _Checkout: Checkout;
let _Esyoil: EsyoilStore;
let _Federalstates: Federalstates;
let _Oilprice: Oilprice;
let _Partner: Partner;
let _User: User;
let _Widerruf: Widerruf;

function initialiseStores(store: Store<any>): void {
  _CaclulatorStore = getModule(CaclulatorStore, store);
  _BlogStore = getModule(Blog, store);
  _Checkout = getModule(Checkout, store);
  _Esyoil = getModule(EsyoilStore, store);
  _Federalstates = getModule(Federalstates, store);
  _Oilprice = getModule(Oilprice, store);
  _Partner = getModule(Partner, store);
  _User = getModule(User, store);
  _Widerruf = getModule(Widerruf, store);
}

export {
  _BlogStore as BlogStore,
  _CaclulatorStore as CalculatorStore,
  _Checkout as CheckoutStore,
  _Esyoil as EsyoilStore,
  _Federalstates as Federalstates,
  initialiseStores,
  _Oilprice as Oilprice,
  _Partner as Partner,
  _User as User,
  _Widerruf as Widerruf,
};
